<template>
  <div
    class="ai-handwriting d-none d-xl-flex"
    :class="{ 'down': directionDown }"
  >
    <ib-handwriting :text="$t('clickToGenerate')" :reverse="reverse" tag="div">
      <template #arrow>
        <svg width="50" height="35" viewBox="0 0 50 35" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:width="'40'" v-bind:class="'arrow-handwriting'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.126 3.495C.76 4.615.485 7.155.378 8.927c-.13 2.141-.164 4.862.91 6.762.38.675 1.542.749 1.897-.01.892-1.905.812-4.433.942-6.537 9.168 15.313 26.436 26.633 44.616 25.46 1.11-.072 1.237-1.627.09-1.753-16.986-1.862-33.006-11.2-40.93-26.385.576.091 1.153.182 1.728.276 2.329.38 4.662.985 7.017.577 1.563-.27 1.886-2.551.57-3.338-1.945-1.163-4.241-1.388-6.435-1.815C8.558 1.73 6.337 1.242 4.097.89 2.532.644 1.494 2.377 1.127 3.495z" fill="currentColor"/></svg>
      </template>
    </ib-handwriting>
  </div>
</template>

<script>
import IbHandwriting from '@/components/_v2/IbHandwriting.vue'

export default {
  name: 'AddDialogAiHandwriting',

  components: { IbHandwriting },

  props: {
    directionDown: {
      type: Boolean,
      default: false
    },

    reverse: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="scss">
.ai-handwriting {
  position: absolute;
  left: 200px;

  .arrow-handwriting {
    margin-bottom: 8px;
  }

  ::v-deep {
    .ib-handwriting-text {
      margin-top: 15px !important;
      font-size: 18px;

      @include media-breakpoint-up($lg) {
        font-size: 22px;
      }
    }
  }

  &.down {
    left: unset;

    .arrow-handwriting {
      transform: scale(-1, -1);
      margin-bottom: 0;
      margin-top: 20px;
    }

    ::v-deep {
      .ib-handwriting-text {
        margin-top: 0 !important;
      }
    }
  }

  img {
    margin: 0;
  }
}
</style>
